export const theme = {
  colors: {
    /* Competitive Studio: матовый графит и тёплый оранжевый (design-spec 02-visual-system) */
    primary: "#ff9b57",
    primaryHover: "#ffad75",
    onPrimary: "#17110d",
    primarySoft: "#ff9b5718",
    secondary: "#10151b",
    background: "#0b0e12",
    navigation: "#10151b",
    surface: "#131a22",
    surfaceHover: "#24303d",
    input: "#1b2430",
    border: "#2b3745",
    borderLight: "#3a4859",
    borderControl: "#65778d",
    text: "#f2f5f8",
    textSecondary: "#b5c0cf",
    textMuted: "#8e9fb3",
    accent: "#ff9b57",
    accentHover: "#ffad75",
    danger: "#ff8a91",
    dangerSoft: "#ff8a9114",
    warning: "#f2c56b",
    success: "#77d6a8",
    info: "#8fb6ed",
    raised: "#1b2430",
    line: "#2b3745",
    successSoft: "#77d6a814",
    warningSoft: "#f2c56b14",
    infoSoft: "#8fb6ed14",
  },
  /* Градиенты намеренно плоские: акцент — цвет, а не декоративная заливка. */
  gradients: {
    primary: "#ff9b57",
    secondary: "#1b2430",
    accent: "#ff9b57",
    surface: "#131a22",
  },
  shadows: {
    small: "0 2px 8px #00000018",
    medium: "0 8px 24px #00000024",
    large: "0 24px 80px #00000055",
    glow: "none",
  },
  borderRadius: {
    small: "6px",
    medium: "10px",
    large: "12px",
    xl: "16px",
  },
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
    xxl: "48px",
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: {
      xs: "12px",
      sm: "14px",
      md: "16px",
      lg: "18px",
      xl: "20px",
      xxl: "24px",
      xxxl: "32px",
    },
    fontWeight: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
      black: 900,
    },
    lineHeight: {
      tight: 1.2,
      normal: 1.5,
      relaxed: 1.75,
    },
  },
  breakpoints: {
    mobile: "480px",
    tablet: "768px",
    desktop: "1024px",
    wide: "1200px",
  },
  radius: {
    field: "10px",
    card: "12px",
    panel: "16px",
    dialog: "16px",
    badge: "6px",
  },
  layout: {
    sidebar: "224px",
    rail: "72px",
    header: "64px",
    headerMobile: "56px",
    content: "1360px",
  },
  motion: {
    fast: "140ms",
    base: "180ms",
    dialog: "220ms",
    ease: "cubic-bezier(0.2, 0.8, 0.2, 1)",
  },
  transitions: {
    fast: "0.15s ease",
    normal: "0.3s ease",
    slow: "0.5s ease",
  },
  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modal: 1040,
    popover: 1050,
    tooltip: 1060,
  },
};
